<template>
	<div class="omapi-card-setting-section">
		<header>
			<h3>Spam Protection</h3>
		</header>
		<div>
			<div class="omapi-flex omapi-spam-settings">
				<div class="omapi-flex-child omapi-input-wrap">
					<common-tooltip tooltip="Add your Google reCAPTCHA v3 site key.">
						<label>reCAPTCHA Site Key:</label>
					</common-tooltip>
					<input
						type="text"
						class="omapi-input"
						placeholder="Enter your reCAPTCHA key here..."
						name="recaptchaSiteKey"
						:value="recaptchaSiteKey"
						@input="$emit('input', $event)"
					/>
				</div>
				<div class="omapi-flex-child omapi-input-wrap">
					<common-tooltip tooltip="Add your Google reCAPTCHA v3 secret key.">
						<label>reCAPTCHA Secret Key:</label>
					</common-tooltip>

					<input
						type="text"
						class="omapi-input"
						placeholder="Enter your reCAPTCHA secret here..."
						name="recaptchaSecretKey"
						:value="recaptchaSecretKey"
						@input="$emit('input', $event)"
					/>
				</div>
			</div>
			<p>
				OptinMonster makes it easy to use Google reCAPTCHA v3 to prevent spam submissions with your optin
				campaigns.
				<a
					class="omapi-link-arrow-after"
					:href="$urls.docs('how-to-use-google-recaptcha-to-prevent-spam/', 'SiteRecaptcha')"
					rel="noopener"
					target="_blank"
					>Learn more</a
				>
			</p>
		</div>
	</div>
</template>

<script lang="js">
export default  {
	props : {
		recaptchaSiteKey : {
			type: String,
			default: '',
		},
		recaptchaSecretKey : {
			type: String,
			default: '',
		},
	},
};
</script>
